import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/dist/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

class Milestones {
  constructor(el, wWidth) {
    this.wWidth = wWidth;
    this.wHeight = window.innerHeight;

    this.$block = $(el);
    this.$wrapper = this.$block.find('.milestones__wrapper');
    this.$milestonesWrap = this.$block.find('.milestones__milestones-wrap');
    this.$milestones = this.$block.find('.milestones__milestones');
    this.$items = this.$block.find('.milestones__item');
    this.$lastItem = this.$items.last();

    this.getSizes();
    this.createTimeline();
  }

  getSizes() {
    this.width = this.$milestones.outerWidth();
    this.lastItemWidth = this.$lastItem.outerWidth();
    this.offset =
      this.wWidth > 767
        ? parseInt(this.$milestones.css('padding-left'), 10) -
          this.lastItemWidth / 2
        : 0;

    this.$pin = this.wWidth > 1023 ? this.$milestonesWrap : this.$wrapper;
    this.$trigger = this.wWidth > 1023 ? this.$milestonesWrap : this.$wrapper;
    this.pinHeight = this.$pin.outerHeight();
  }

  createTimeline() {
    this.timeline = gsap.timeline({
      scrollTrigger: {
        trigger: this.$trigger.get(0),
        start: () => {
          let top = this.wHeight / 2 - this.pinHeight / 2;
          top = Math.round(top);
          return `top top+=${top}`;
        },
        end: () => {
          return `+=${this.width * 1.2}`;
        },
        pin: this.$pin.get(0),
        scrub: true,
      },
    });

    // calculate duration
    let totalDuration = 0;

    this.$items.each((i, el) => {
      let duration = 0;
      const isLarge = $(el).hasClass('milestones__item--large');
      const isMedium = $(el).hasClass('milestones__item--medium');

      if (isLarge) {
        duration += 0.6;
      } else if (isMedium) {
        duration += 0.4;
      } else {
        duration += 0.2;
      }

      this.timeline.to(
        el,
        {
          duration,
          onUpdate() {
            const progress = this.progress().toFixed(2);
            el.style.setProperty('--progress', progress);
          },
        },
        totalDuration
      );

      totalDuration += duration;
    });

    // main horizontal animation
    this.timeline.to(
      this.$milestones.get(0),
      {
        x: () => {
          return -this.width + this.lastItemWidth + this.offset;
        },
        duration: totalDuration,
        ease: 'none',
      },
      0
    );
  }

  onResize(wWidth) {
    this.wWidth = wWidth;
    this.wHeight = window.innerHeight;

    // kill current timeline
    if (this.timeline) {
      this.timeline.revert();
      this.timeline = null;
    }

    // create new one
    this.getSizes();
    this.createTimeline();
  }
}

export default Milestones;
